import React,{Fragment} from 'react';
import moment from 'moment';
import {speedWithUiUnit} from '../data-source/prefs';

const Waypoint = ({data}) => {
    const speed = data.gprmc_gs ? speedWithUiUnit(data.gprmc_gs) : "";
    const lat_deg = data.gprmc_lat ? data.gprmc_lat.substr(0,2) : ""
    const lat_min = data.gprmc_lat ? data.gprmc_lat.substr(2) : ""
    const long_deg = data.gprmc_long ? data.gprmc_long.substr(0,3) : ""
    const long_min = data.gprmc_long ? data.gprmc_long.substr(3) : ""
    const messages = {
        "ACCStart": "Engine Started",
        "ACCStop" : "Engine Stopped" 
    }
    const message = typeof messages[data.message] !== 'undefined' ? messages[data.message] : ""
    const date = moment(data.utc).format("YYYY-MM-DD HH:mm")
    const track = !isNaN(parseFloat(speed)) && parseFloat(speed) > 1 && typeof data.gprmc_track !== 'undefined' ? <span>{Math.floor(parseFloat(data.gprmc_track))}&#176;</span> : ""
    const googleMapLink = data.gprmc_lat && data.gprmc_long ? <a href={`https://maps.google.com/maps?f=q&hl=en&q=${lat_deg}+${lat_min}${data.gprmc_lat_loc},${long_deg}+${long_min}${data.gprmc_long_loc}`} target="blank">{data.gprmc_lat_loc}{lat_deg}&#176;{lat_min}' {data.gprmc_long_loc}{long_deg}&#176;{long_min}'</a> : <Fragment/>
    return( 
    <div style={{fontFamily: '"Lucida Console", Monaco, monospace',fontSize: "11px",display:"grid",gridTemplateColumns:"2fr 3fr 1fr 1fr 2fr",columnGap:"20px",justifyItems:"start"}}>
        <span>{date}</span>
        <span>{googleMapLink}</span>
        <span>{speed}</span>
        <span>{track}</span>
        <span>{message}</span>
    </div>);
}

export default Waypoint;